import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Cookie } from 'lucide-react';
interface CookieBannerProps {
  onOpenCookiePolicy: () => void;
}
export function CookieBanner({
  onOpenCookiePolicy
}: CookieBannerProps) {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const consent = localStorage.getItem('vanii-cookie-consent');
    if (!consent) {
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);
  function handleAccept() {
    localStorage.setItem('vanii-cookie-consent', 'accepted');
    setIsVisible(false);
  }
  function handleReject() {
    localStorage.setItem('vanii-cookie-consent', 'rejected');
    setIsVisible(false);
  }
  return <AnimatePresence data-id="element-66">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      damping: 25,
      stiffness: 200
    }} className="fixed bottom-0 left-0 right-0 z-[90] p-4 md:p-6" data-id="element-67">
          <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-2xl border border-stone-100 p-6 md:p-8" data-id="element-68">
            <div className="flex flex-col md:flex-row items-start md:items-center gap-4" data-id="element-69">
              <div className="flex items-start gap-3 flex-1" data-id="element-70">
                <div className="text-violet-600 mt-0.5 shrink-0" data-id="element-71">
                  <Cookie size={24} data-id="element-72" />
                </div>
                <div data-id="element-73">
                  <p className="text-stone-800 font-medium mb-1" data-id="element-74">
                    Utilizamos cookies
                  </p>
                  <p className="text-stone-500 text-sm leading-relaxed" data-id="element-75">
                    Esta web utiliza cookies para mejorar tu experiencia.{' '}
                    <button onClick={onOpenCookiePolicy} className="text-violet-600 hover:underline font-medium" data-id="element-76">
                      Política de Cookies
                    </button>
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-3 shrink-0 w-full md:w-auto" data-id="element-77">
                <button onClick={handleReject} className="flex-1 md:flex-none px-5 py-2.5 text-sm font-medium text-stone-600 border border-stone-200 rounded-full hover:bg-stone-50 transition-colors" data-id="element-78">
                  Rechazar
                </button>
                <button onClick={handleAccept} className="flex-1 md:flex-none px-5 py-2.5 text-sm font-medium text-white bg-violet-600 rounded-full hover:bg-violet-700 transition-colors" data-id="element-79">
                  Aceptar
                </button>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}